<template>
  <div class="stock-source-pane">
    <ExternalContentView
      v-if="isActivated"
      ref="content"
      :endpoint="endpoint"
      :page-size="pageSize"
      :extra-params="params"
      :show-search="false"
      :external-preview="true"
      @onSelectedItems="onSelectedItems"
      @open-preview="(item) => $emit('open-preview', item)"
    />
  </div>
</template>

<script>
import ExternalContentView from '@frontend/components/modules/file-browser/modals/ExternalContentView.vue';
import externalPaneMixin from '@frontend/components/modules/file-browser/modals/externalPaneMixin';
import { GRID_PAGE_SIZE } from '@frontend/constants/select-image-grid';
import {
  SOURCE_TYPE_BYNDER,
  SOURCE_TYPE_ITS_RAPID,
  SOURCE_TYPE_PIXABAY,
  SOURCE_TYPE_SALSIFY,
} from '@frontend/constants/stock-image-source';

const SOURCE_ENDPOINTS = {
  [SOURCE_TYPE_ITS_RAPID]: '/stock/retrieve-itsrapid',
  [SOURCE_TYPE_PIXABAY]: '/stock/retrieve-pixabay',
  [SOURCE_TYPE_BYNDER]: '/bynder/retrieve-assets',
  [SOURCE_TYPE_SALSIFY]: '/salsify/retrieve-assets',
};

export default {
  name: 'StockSourcePane',
  components: {
    ExternalContentView,
  },
  mixins: [externalPaneMixin],
  props: {
    // JSON rather than an Array prop: custom-element attributes arrive as strings.
    sources: {
      type: String,
      default: '[]',
    },
    pageSize: {
      type: Number,
      default: GRID_PAGE_SIZE,
    },
  },
  data() {
    return {
      // The source switch itself lives in the toolbar (StockSourceControls); this only follows it.
      activeIndex: 0,
      // vue-custom-element upgrades on render, not on open: an eager grid would cost every page load a fetch.
      isActivated: false,
    };
  },
  computed: {
    sourceList() {
      try {
        const parsed = JSON.parse(this.sources);

        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    },
    activeSource() {
      return this.sourceList[this.activeIndex]?.value || SOURCE_TYPE_ITS_RAPID;
    },
    endpoint() {
      return SOURCE_ENDPOINTS[this.activeSource] || SOURCE_ENDPOINTS[SOURCE_TYPE_ITS_RAPID];
    },
  },
  methods: {
    onSelectedItems(items) {
      this.$emit('onSelectedItems', items);
    },

    setSource(index) {
      if (index === this.activeIndex) {
        return;
      }

      this.activeIndex = index;
      this.$emit('onSelectedItems', []);
    },

    setParams(next) {
      this.isActivated = true;
      this.mergeParams(next);
    },
  },
};
</script>
